import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      nav("/discover");
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:block bg-[#333333] text-white p-12 relative overflow-hidden">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E]">◇ Members only</div>
        <h2 className="font-heading text-5xl mt-6 leading-tight">Welcome<br/>back to<br/>your studio.</h2>
        <p className="font-body text-white/60 mt-8 max-w-sm">Pick up where you left off. Your sets, your saved products, your community.</p>
        <div className="absolute bottom-8 left-12 font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
          VORASTYLE · 2026 © COLLECTIVE
        </div>
      </div>
      <form onSubmit={submit} className="p-8 sm:p-16 flex flex-col justify-center max-w-md mx-auto w-full">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E]">◇ Login</div>
        <h1 className="font-heading text-4xl mt-4">Sign in</h1>
        <div className="mt-10 space-y-5">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#595959]">Email</label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none border-[#E5E5E5] focus-visible:ring-0 focus-visible:border-[#333333] py-6 mt-2" />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#595959]">Password</label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-[#E5E5E5] focus-visible:ring-0 focus-visible:border-[#333333] py-6 mt-2" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-[#9CA47E] font-body">{err}</div>}
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full rounded-none bg-[#333333] hover:bg-[#333] py-6 text-base">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <div className="font-body text-sm text-[#595959]">
            New here? <Link to="/register" className="underline underline-offset-4 text-[#333333]">Create account</Link>
          </div>
        </div>
      </form>
    </div>
  );
}
